var _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCheckGreenIcon = function SvgCheckGreenIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -0.00195312,
    width: 17.998,
    height: 17.998,
    rx: 8.99902,
    fill: "#35973E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2446 10.5244C7.30866 10.4572 7.36764 10.3923 7.42979 10.3305C7.99099 9.77179 8.55257 9.21357 9.11415 8.65524C9.63613 8.13633 10.1581 7.61752 10.6802 7.09871C11.166 6.61595 11.6509 6.13214 12.1383 5.65112C12.3695 5.42297 12.6485 5.34501 12.9611 5.43237C13.2719 5.51916 13.4718 5.72899 13.548 6.04238C13.6197 6.33679 13.5473 6.60368 13.3342 6.81859C12.6631 7.49543 11.9868 8.16731 11.3126 8.84109C10.9975 9.15603 10.6826 9.47105 10.3676 9.78608C9.50963 10.6441 8.65154 11.5022 7.79353 12.3602C7.47851 12.6752 6.99748 12.6755 6.68292 12.3611C6.01327 11.6915 5.3437 11.0218 4.67414 10.3523C4.38491 10.063 4.34137 9.63514 4.55915 9.2899C4.82566 8.86737 5.44411 8.76926 5.82972 9.13741C6.10907 9.40412 6.38171 9.678 6.65742 9.94863C6.84988 10.1375 7.04255 10.3263 7.2446 10.5244Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckGreenIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check-green-icon.1205f088.svg";
export { ForwardRef as ReactComponent };